import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ProfitAndLossAccount from "./ProfitAndLossAccount";
import { Container, Row, Col } from "react-bootstrap";
import RegularMemership from "./RegularMemership";
import OtherMemberships from "./OtherMemberships";
import NetCashFlow from "./NetCashFlow";
import AddButton from "../common/AddButton";
import { toast } from "react-toastify";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { selectSettlementFormValues } from "../../../redux/reducers/settlementFormSlice";
import { createNewSettlementInitiateData } from "../../../redux/reducers/apiSlice";
import { selectAuth } from "../../auth/auth.selector";

function SettlementsTables() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);

  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const selectedTab = useSelector((state) => state.tabs.selectedTab);
  const selectedTabDates = useSelector((state) => state.tabs.selectedTabDates);
  const clickedRowValue = useSelector(
    (state) => state.clickedRow.clickedRowValue
  );
  const settlementFormValuesNew = useSelector(selectSettlementFormValues);
  const { initiateData, loading, error } = useSelector((state) => state.api);

  const selectedGymQueryParam = settlementFormValuesNew?.selectedGym
    ? `&gym_id=${settlementFormValuesNew?.selectedGym?.value}`
    : "";
  const selectedYearParam = settlementFormValuesNew.selectedYear
    ? `&year=${settlementFormValuesNew.selectedYear}`
    : "";
  const startDateQueryParam =
    settlementFormValuesNew.selectedSettlementStartDate
      ? `&from_date=${settlementFormValuesNew.selectedSettlementStartDate}`
      : "";
  const endDateQueryParam = settlementFormValuesNew.selectedSettlementEndDate
    ? `&to_date=${settlementFormValuesNew.selectedSettlementEndDate}`
    : "";
  const queryParameters = `${selectedGymQueryParam}${selectedYearParam}${startDateQueryParam}${endDateQueryParam}`;

  const [initiateClicked, setInitiateClicked] = useState(false);

  const onClickInitiate = (e) => {
    e.preventDefault();
    createSettlement(settlementFormValuesNew);

    confirmAlert({
      title: "Verify & Create",
      message:
        "Approval will be sent to the authorized person. Click on Verify & Create to continue.",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleInitiate(),
        },
        {
          label: "No",
          onClick: () => alert("Click No"),
        },
      ],
    });
  };

  const addValue = (item1, item2) => {
    return Math.round(parseFloat(item1) + parseFloat(item2));
  };

  let bodyFinalSettlement = {
    gym_id: settlementFormValuesNew?.selectedGym?.value,
    from_date: "",
    to_date: "",
    net_revenue: 0,
    wtf_share: 0,
    gym_share: 0,
    is_gst: 0,
    is_minimum: 0,
    minimum_amount: 0,
    gst_on_gym_share: 0,
    gst_on_wtf_facility: 0,
    bill_raised_to_gym: 0,
    gym_name: settlementFormValuesNew?.selectedGym?.label,
    month: 0,
  };

  let bodyCreateSettlement = {
    gym_id: settlementFormValuesNew?.selectedGym?.value,
    from_date: "",
    to_date: "",
    type: "",
    year: new Date().getFullYear(),
    isTouched: false,
  };

  let bodyFinal;

  function createSettlement(content) {
    const settlementDetails = clickedRowValue;

    const settlementDetailsDraft = clickedRowValue?.data;

    const startDate = content?.selectedSettlementStartDate;
    const endDate = content?.selectedSettlementEndDate;
    // const gymId = settlementFormValuesNew?.selectedGym?.value;

    let body;
    if (settlementDetailsDraft[0].is_gym_gst === 1) {
      body = {
        from_date: startDate,
        to_date: endDate,
        is_gst: settlementDetailsDraft[0].is_gym_gst,
        is_minimum: settlementDetailsDraft[0].is_minimum,
        minimum_amount: settlementDetailsDraft[0].minimum_amount,
        gst_on_wtf_facility: addValue(
          settlementDetails.data.length > 0
            ? settlementDetails.wtf_gst_final
            : 0,
          settlementDetails.cash_flow_other_membership.gst_wtf_share
        ),
        bill_raised_to_gym: addValue(
          settlementDetails.data.length > 0
            ? settlementDetails.bill_raised_to_gym
            : 0,
          settlementDetails.cash_flow_other_membership.bill_raised_to_gym
        ),
        month: new Date(startDate).getMonth() + 1,

        net_revenue: {
          basic_membership: settlementDetailsDraft[0].net_revenue,
          other_membership:
            settlementDetails.cash_flow_other_membership.net_revenue,
          total: addValue(
            settlementDetailsDraft[0].net_revenue,
            settlementDetails.cash_flow_other_membership.net_revenue
          ),
        },
        wtf_share: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.revenue_share_regular_membership.wtf_share
              : 0,
          other_membership:
            settlementDetails.cash_flow_other_membership.total_wtf_share,
          total: addValue(
            settlementDetails.revenue_share_regular_membership.wtf_share,
            settlementDetails.cash_flow_other_membership.total_wtf_share
          ),
        },
        gym_share: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final
              : 0,
          other_membership:
            settlementDetails.cash_flow_other_membership.total_gym_share,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final
              : 0,
            settlementDetails.cash_flow_other_membership.total_gym_share
          ),
        },
        gst: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.gym_gst_final
              : 0,
          other_membership:
            settlementDetails.cash_flow_other_membership.gst_owner_share,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.gym_gst_final
              : 0,
            settlementDetails.cash_flow_other_membership.gst_owner_share
          ),
        },
        net_cash_flow_gym: {
          basic_membership: settlementDetails.gym_share_final_with_gst,
          other_membership:
            settlementDetails.cash_flow_other_membership.net_cash_flow_gym,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final_with_gst
              : 0,
            settlementDetails.cash_flow_other_membership.net_cash_flow_gym
          ),
        },
      };
    } else {
      body = {
        from_date: startDate,
        to_date: endDate,
        is_gst: settlementDetailsDraft[0].is_gym_gst,
        is_minimum: settlementDetailsDraft[0].is_minimum,
        minimum_amount: settlementDetailsDraft[0].minimum_amount,
        gst_on_wtf_facility: addValue(
          settlementDetails.data.length > 0
            ? settlementDetails.wtf_gst_final
            : 0,
          settlementDetails.cash_flow_other_membership.gst_wtf_share
        ),
        bill_raised_to_gym: addValue(
          settlementDetails.data.length > 0
            ? settlementDetails.bill_raised_to_gym
            : 0,
          settlementDetails.cash_flow_other_membership.bill_raised_to_gym
        ),
        month: new Date(startDate).getMonth() + 1,

        net_revenue: {
          basic_membership: settlementDetailsDraft[0].net_revenue,
          other_membership:
            settlementDetails.cash_flow_other_membership.net_revenue,
          total: addValue(
            settlementDetailsDraft[0].net_revenue,
            settlementDetails.cash_flow_other_membership.net_revenue
          ),
        },
        wtf_share: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.revenue_share_regular_membership.wtf_share
              : 0,
          other_membership:
            settlementDetails.cash_flow_other_membership.total_wtf_share,
          total: addValue(
            settlementDetails.revenue_share_regular_membership.wtf_share,
            settlementDetails.cash_flow_other_membership.total_wtf_share
          ),
        },
        gym_share: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final
              : 0,
          other_membership:
            settlementDetails.cash_flow_other_membership.total_gym_share,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final
              : 0,
            settlementDetails.cash_flow_other_membership.total_gym_share
          ),
        },
        gst: {
          basic_membership:
            settlementDetails.data.length > 0
              ? settlementDetails.data[0].gst
              : 0,
          other_membership: settlementDetails.cash_flow_other_membership.gst,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.data[0].gst
              : 0,
            settlementDetails.cash_flow_other_membership.gst
          ),
        },
        net_cash_flow_gym: {
          basic_membership: settlementDetails.gym_share_final_with_gst,
          other_membership:
            settlementDetails.cash_flow_other_membership.net_cash_flow_gym,
          total: addValue(
            settlementDetails.data.length > 0
              ? settlementDetails.gym_share_final_with_gst
              : 0,
            settlementDetails.cash_flow_other_membership.net_cash_flow_gym
          ),
        },
      };
    }

    bodyFinalSettlement.from_date = startDate;
    bodyFinalSettlement.to_date = endDate;
    bodyFinalSettlement.net_revenue = addValue(
      settlementDetailsDraft[0].net_revenue,
      settlementDetails.cash_flow_other_membership.net_revenue
    );
    bodyFinalSettlement.wtf_share = addValue(
      settlementDetails.revenue_share_regular_membership.wtf_share,
      settlementDetails.cash_flow_other_membership.total_wtf_share
    );
    bodyFinalSettlement.gym_share = addValue(
      settlementDetails.revenue_share_regular_membership.gym_share,
      settlementDetails.cash_flow_other_membership.total_gym_share
    );
    bodyFinalSettlement.is_gst = settlementDetailsDraft[0].is_gym_gst;
    bodyFinalSettlement.is_minimum = settlementDetailsDraft[0].is_minimum;
    bodyFinalSettlement.minimum_amount =
      settlementDetailsDraft[0].minimum_amount;
    bodyFinalSettlement.gst_on_gym_share = addValue(
      settlementDetails.data.length > 0 ? settlementDetails.gym_gst_final : 0,
      settlementDetails.cash_flow_other_membership.gst_owner_share
    );
    bodyFinalSettlement.gst_on_wtf_facility = addValue(
      settlementDetails.data.length > 0 ? settlementDetails.wtf_gst_final : 0,
      settlementDetails.cash_flow_other_membership.gst_wtf_share
    );
    bodyFinalSettlement.bill_raised_to_gym = addValue(
      settlementDetails.data.length > 0
        ? settlementDetails.bill_raised_to_gym
        : 0,
      settlementDetails.cash_flow_other_membership.bill_raised_to_gym
    );
    bodyFinalSettlement.month = new Date(startDate).getMonth() + 1;

    bodyFinal = {
      date_from: startDate,
      date_to: endDate,
      month: new Date(startDate).getMonth() + 1,
      year: bodyCreateSettlement.year,
      gym_id: bodyCreateSettlement.gym_id,
      is_minimum: bodyFinalSettlement.is_minimum ? 1 : 0,
      minimum_amount: bodyFinalSettlement.minimum_amount
        ? bodyFinalSettlement.minimum_amount
        : 0,
      is_gst: bodyFinalSettlement.is_gst ? 1 : 0,
      net_revenue: body.net_revenue.total.toString(),
      gym_share: body.gym_share.total.toString(),
      wtf_share: body.wtf_share.total.toString(),
      gst_amount: body.gst.total.toString(),
      net_cash_flow_gym:
        bodyFinalSettlement.is_gst && bodyFinalSettlement.is_gst === 1
          ? body.net_cash_flow_gym.total
          : addValue(
              settlementDetails.data.length > 0
                ? settlementDetails.gym_share_final
                : 0,
              settlementDetails.cash_flow_other_membership.total_gym_share
            ).toString(),
      settlement_status: "draft",
      json_details: settlementDetails,
      is_gst_paid_by_wtf:
        bodyFinalSettlement.is_gst && bodyFinalSettlement.is_gst === 1 ? 0 : 1,
      bill_raised_to_gym: addValue(
        settlementDetails.data.length > 0
          ? settlementDetails.bill_raised_gym
          : 0,
        settlementDetails.cash_flow_other_membership.bill_raised_gym
      ).toString(),
    };

    // console.log("BODY ", body);
    console.log("FINAL SETTLEMENT", bodyFinal);
    // modalService.open(content, { centered: true, backdrop: 'static', keyboard: false });
    // startTimer();
    // apiRep.approvalBody.is_touched = true;
    // apiRep.approvalBody.gym_id = bodyCreateSettlement.gym_id;
    // apiRep.approvalBody.approval_status = 'PENDING'
  }

  const handleInitiate = () => {
    dispatch(
      createNewSettlementInitiateData({
        queryParameters,
        token: decryptedText?.token,
      })
    );
    setInitiateClicked(true);
  };

  useEffect(() => {
    if (initiateClicked && initiateData?.status) {
      toast.success(initiateData?.message || "Settlement Initiated 😮‍💨");
      navigate("/");
    } else if (initiateClicked) {
      toast.error(initiateData?.message || "Something Wrong 🫤");
    }
  }, [initiateData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="settlementMains">
      <div className="settlementDurationContainer">
        <span className="settlementDuration">
          Settlement duration:
          <b>
            {selectedTabDates?.settlementFrom
              ? selectedTabDates?.settlementFrom
              : settlementFormValuesNew?.selectedSettlementStartDate
              ? moment(
                  settlementFormValuesNew.selectedSettlementStartDate
                )?.tz("Asia/Kolkata")?.format("DD-MM-YYYY")
              : "-"}{" "}
            to{" "}
            {selectedTabDates?.settlementTo
              ? selectedTabDates?.settlementTo
              : settlementFormValuesNew?.selectedSettlementEndDate
              ? moment(
                  settlementFormValuesNew.selectedSettlementEndDate
                )?.tz("Asia/Kolkata")?.format("DD-MM-YYYY")
              : "-"}
          </b>
        </span>
      </div>

      <Container fluid className="container">
        <Row>
          <Col>
            <ProfitAndLossAccount settlementDetails={clickedRowValue} />
          </Col>
        </Row>
        <Row>
          <Col>
            <h3 className="titleTableHead">Regular Membership</h3>
            <RegularMemership
              clickedRowValue={
                clickedRowValue?.data?.[0] || clickedRowValue?.data || {}
              }
              wtfShare={
                clickedRowValue?.revenue_share_regular_membership?.wtf_share
              }
              gymShare={
                clickedRowValue?.revenue_share_regular_membership?.gym_share
              }
              gstWtfFacilities={clickedRowValue?.gst_wtf_facilities}
              billRaised={clickedRowValue?.bill_raised_gym}
              netCashFlowWTF={clickedRowValue?.net_cash_flow_wtf}
              netCashFlowGym={clickedRowValue?.net_cash_flow_gym}
            />
          </Col>
        </Row>
        {clickedRowValue?.is_minimum === 0 ? (
          <Row>
            <Col>
              <h3 className="titleTableHead">Other Membership</h3>
              <OtherMemberships
                clickedRowValue={
                  clickedRowValue?.cash_flow_other_membership || []
                }
              />
            </Col>
          </Row>
        ) : null}
        <Row>
          <Col>
            <h3 className="titleTableHead">Net Cash Flow</h3>
            <NetCashFlow settlementDetails={clickedRowValue || {}} />
          </Col>
        </Row>
        {selectedTab !== "settlement-systems" && (
          <Row>
            <Col>
              <AddButton
                buttonText="+ Initiate Settlement Process"
                onClickButton={onClickInitiate}
              />
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default SettlementsTables;
